'use client';

import {useState, useEffect} from 'react';
import {useMediaQuery} from 'react-responsive';
import Image from 'next/image';
import Link from 'next/link';
import integrations from '../../data/integrations';

const Integrations = () => {
  const screenWidth = useMediaQuery({query: '(max-width: 768px)'});
  const [isVisible, setVisible] = useState(false);
  const [logoArr, setLogoArr] = useState(integrations);

  useEffect(() => {
    const logoArr = !screenWidth ? integrations : isVisible ? integrations : integrations.slice(0, 6);
    setLogoArr(logoArr);
  }, [screenWidth, isVisible]);

  const onClick = () => {
    setVisible(isVisible => !isVisible);
  };

  const images = logoArr.map((el, index) => {
    const {src, company} = el;
    return (
      <div key={index} className='logo'>
        <div key={index} className='image-container'>
          <Image src={src} className='image' alt='logo' fill/>
        </div>
        <p className='company'>{company}</p>
      </div>
    );
  });

  return (
    <section className='integrations' id='integrations'>
      <div className='container'>
        <h3 className='subtitle'>Integrations</h3>
        <h2 className='title'>Integrate with hundreds of data sources</h2>
        <div className='wrapper'>
          <div className='logos'>{images}</div>
        </div>
        <p className='and-more'>...and more</p>
        <Link href='platform#integrations' legacyBehavior>
          <a className='arrow-link' onClick={onClick}>
            {isVisible ? 'Hide all' : 'View more'}
            <span className='arrow-wrapper'>
              <span className='arrow'></span>
            </span>
          </a>
        </Link>
      </div>
    </section>
  );
};

export default Integrations;

